const closeButtonLabel = "Schliessen";
const deCH = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  deCH as default
};
